import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

import {
  Address, ADDRESS_NORMALIZER,
  ADDRESS_SERIALIZER,
  ConverterService, InterceptorUtil, Occ, OccEndpointsService,
  OccUserAddressAdapter, OCC_USER_ID_ANONYMOUS, OCC_USER_ID_GUEST, USE_CLIENT_TOKEN
} from '@spartacus/core';
import { CustomUserAddressAdapter } from './custom-user-address.adapter';

@Injectable()
export class CustomOccUserAddressAdapter extends OccUserAddressAdapter implements CustomUserAddressAdapter {
  constructor(
    protected http: HttpClient,
    protected occEndpoints: OccEndpointsService,
    protected converter: ConverterService,
  ) {
    super(http, occEndpoints, converter);
  }

  update(userId: string, addressId: string, address: Address): Observable<{}> {
    const url = this.occEndpoints.buildUrl('addressCustomUpdate', {
      urlParams: {
        userId,
        addressId
      }
    });
    const headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    address = this.converter.convert(address, ADDRESS_SERIALIZER);

    return this.http
      .put(url, address, { headers })
      .pipe(catchError((error: any) => throwError(error)));
  }


  loadAllByZone(userId: string, zone?: string): Observable<Address[]> {
    const url = this.occEndpoints.buildUrl('addressesZone', { urlParams: { userId, zone: !!zone ? zone : '' } });
    let headers = new HttpHeaders({
      'Content-Type': 'application/json',
    });
    if (userId === OCC_USER_ID_ANONYMOUS || userId === OCC_USER_ID_GUEST) {
      headers = InterceptorUtil.createHeader(USE_CLIENT_TOKEN, true, headers);
    }

    return this.http
      .get<Occ.AddressList>(url, { headers })
      .pipe(
        catchError((error: any) => throwError(error)),
        map((addressList) => addressList.addresses),
        this.converter.pipeableMany(ADDRESS_NORMALIZER)
      );
  }
}
